import type { ICampaignGroup } from '../types';

import { useCampaignGroupUpdateMutation } from '~/api/graphql/mutations/campaignGroupUpdate.generated';
import { CAMPAIGN_MSG } from '~/modules/campaign/constants';
import { useCampaignGroupStore } from '../stores';
import { useToast } from '~/hooks/useToast';

export interface IUpdateCampaignInfo<T extends ICampaignGroup> {
  onUpdate: (id: string, payload: Partial<T>) => Promise<T | undefined>;
}
export const useMutationCampaignGroupInfo = <
  T extends ICampaignGroup,
>(): IUpdateCampaignInfo<T> => {
  const { shopifyToast } = useToast();
  // const { handleSyncToLivePage: handleSyncToLivePageCGTemplate } = useCGTemplateSyncMetafield();

  const upsertCampaignGroup = useCampaignGroupStore((state) => state.upsertCampaignGroup);
  const findCampaignGroupById = useCampaignGroupStore((state) => state.findCampaignGroupById);
  const campaignGroupMutation = useCampaignGroupUpdateMutation();

  const onUpdate = async (id: string, payload: Partial<T>): Promise<T | undefined> => {
    try {
      const campaignGroup = findCampaignGroupById(id);
      if (!campaignGroup) return;

      const { campaignGroupUpdate } = await campaignGroupMutation.mutateAsync({
        id: campaignGroup.id,
        input: payload,
      });

      if (!campaignGroupUpdate) {
        shopifyToast(CAMPAIGN_MSG.UPDATE.FAILED, { isError: true });
        return;
      }

      // const isSyncLivePage = campaignAllowedSyncWithLivePages(campaignGroupUpdate as T);
      // if (isSyncLivePage) await handleSyncToLivePageCGTemplate();

      upsertCampaignGroup({ ...campaignGroup, title: campaignGroupUpdate.title });
      return campaignGroupUpdate as T;
    } catch (error) {
      shopifyToast(CAMPAIGN_MSG.UPDATE.FAILED, { isError: true });
      return;
    }
  };

  return {
    onUpdate,
  };
};
